document.addEventListener('DOMContentLoaded', function() {
    const popup = document.querySelector('[data-rewards-popup]');
    const closeButton = popup.querySelector('.rewards-popup__close');
    const overlay = popup.querySelector('.rewards-popup__overlay');
    const content = popup.querySelector('.rewards-popup__content');
  
    function openPopup() {
      popup.classList.add('rewards-popup--active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling when popup is open
    }
  
    function closePopup() {
      overlay.style.animation = 'fadeIn 0.3s ease reverse';
      content.style.animation = 'slideIn 0.3s ease reverse';
      
      setTimeout(() => {
        popup.classList.remove('rewards-popup--active');
        document.body.style.overflow = ''; // Restore scrolling
        // Reset animations
        overlay.style.animation = '';
        content.style.animation = '';
      }, 300); // Match this to the animation duration
    }
  
    // Open popup when trigger element is clicked
    document.querySelectorAll('[data-rewards-popup-trigger]').forEach(trigger => {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        openPopup();
      });
    });
  
    // Close popup when close button is clicked
    closeButton.addEventListener('click', closePopup);
  
    // Close popup when overlay is clicked
    overlay.addEventListener('click', closePopup);
  
    // Close popup when Escape key is pressed
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && popup.classList.contains('rewards-popup--active')) {
        closePopup();
      }
    });
  });